import * as BsIcons from "react-icons/bs";
import * as FaIcons from "react-icons/fa";

export const SidebarMap = [
  {
    category: "Personal",
    items: [
      {
        title: "Résumé",
        path: "/history",
        icon: <BsIcons.BsFileCode />,
        cName: "nav-text",
      },
    ],
  },
  {
    category: "Tools",
    items: [
      {
        title: "Recipe Finder",
        path: "/recipefinder",
        icon: <FaIcons.FaUtensils />,
        cName: "nav-text",
      },
      {
        title: "Mental Health",
        path: "/mentalhealth",
        icon: <FaIcons.FaBrain />,
        cName: "nav-text",
      },
    ],
  },
  {
    category: "Games",
    items: [
      {
        title: "Guessing Game",
        path: "/guessinggame",
        icon: <FaIcons.FaQuestion />,
        cName: "nav-text",
      },
      {
        title: "CptCaleb",
        path: "/cptcaleb",
        icon: <FaIcons.FaGamepad />,
        cName: "nav-text",
      },
    ],
  },
  {
    category: "Archives",
    items: [
      {
        title: "BlueLink",
        path: "/bluelink",
        icon: <FaIcons.FaLink />,
        cName: "nav-text",
      },
    ],
  },
];
